/* src/app/old-settings/edit-email-template/edit-email-template.component.scss */
/*# sourceMappingURL=edit-email-template.component-SJPBXOQY.css.map */
